import { extendTheme } from "@chakra-ui/react";

const config = {
  initialColorMode: "light", // Tema padrão claro
  useSystemColorMode: false, // Não seguir o sistema operacional
};

const theme = extendTheme({ config });

export default theme;
